import { render, staticRenderFns } from "./singleElection.vue?vue&type=template&id=1b0935f4&scoped=true&lang=html&"
import script from "./singleElection.vue?vue&type=script&lang=js&"
export * from "./singleElection.vue?vue&type=script&lang=js&"
import style0 from "./singleElection.vue?vue&type=style&index=0&id=1b0935f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0935f4",
  null
  
)

export default component.exports